import { Button } from '@mui/material';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { useSelector } from 'react-redux';
import Spinner from '../../../../components/spinner/spinner';
import { USER_ROLES } from '../../../../utils/constants';
import { APIUtils } from '../../../../utils/apiutils';
import httpClient from '../../../../services/http';
import {emptyCart} from '../../../../redux/actions/cartactions';
import { objectToFormData } from '../../../../utils/utils';
import TreatuLogo from '../../../../assets/logos/treatu_logo.png';
import useTestCartData from '../hooks/useTestCartData';

const TestPlaceOrderBtn = () => {
    const {cart, orderInfo, cartPrice, serviceType, patientName, patientAge, patientNumber, prescription, resetCartOrderData} = useTestCartData();
    const navigate = useNavigate();
    const userState = useSelector(state => state.auth.user);
    const [placingOrder, setPlacingOrder] = useState(false);
    const testIds = JSON.stringify(cart.map(test => test.id));

    const createTestRequest = async (requestData) => {
        try {
            const payload = {...requestData, testIds};
            if (prescription) {
                payload.prescription = prescription;
            }
            if (orderInfo.coordinate) {
                payload.coordinate = JSON.stringify(orderInfo.coordinate);
            }
            if (orderInfo.city) {
                payload.city = orderInfo.city;
            }
            const formData = objectToFormData(payload);
            const res = await httpClient.post(APIUtils.getAPIEndpoint('create-test-request'), formData);
            // testRequestData
            console.log({res});
            Swal.fire('Payment Success!', '', 'success');
            emptyCart();
            resetCartOrderData();
            navigate('/my-requests');
        } catch (error) {
            console.log(error);
            Swal.fire('Something Went Wrong while updating your order status!', '', 'error');
        }
    };

    const isLoginValid = () => {
        if (userState && userState.role && userState.role === USER_ROLES.PATIENT) {
            return true;
        }

        return false;
    };

    const handlePlaceOrder = async () => {
        if (!isLoginValid()) {
            Swal.fire('Sorry!', 'Please, login before you place your order.', 'error');
            return;
        }
        if (orderInfo?.testType === 1 && !prescription) {
            Swal.fire('Please upload prescription.', 'error');
            return;
        }
        setPlacingOrder(true);
        // const { patientName, patientAge, patientNumber } = cartOrderData;
        const payload = {
            amount: cartPrice,
            description: 'Tests for patients',
            productName: 'Lab Tests',
            email: userState.email,
            contact: patientNumber,
            personName: patientName,
            patientInfo: JSON.stringify({ patientName, patientAge, patientNumber }),
            testServiceType: serviceType,
            requestFor: 'Pathology Lab',
            testdatetime: orderInfo.testDate,
            location: orderInfo.selectedLocation,
        };
        try {
            const orderData = await httpClient.post(APIUtils.getAPIEndpoint('create-request-order'), payload);
            const res = orderData?.data;
            if (res?.success) {
                const options = {
                    key: res.keyId,
                    amount: res.amount,
                    currency: 'INR',
                    name: res.product_name,
                    description: res.description,
                    image: TreatuLogo,
                    'order_id': res.orderId,
                    prefill: {
                        contact: res.contact,
                        name: res.name,
                        email: res.email
                    },
                    notes: {
                        description: res.description
                    },
                    theme: {
                        color: '#2300a3'
                    },
                    handler: response => {
                        console.log(response, 'response');
                        // if (response.status_code === 200) {
                        // Swal.fire('Payment Success!', '', 'success');
                        Swal.fire({
                            title: 'Please Wait!',
                            html: 'Processing the payment...',
                            allowOutsideClick: false,
                            showConfirmButton: false,
                            didOpen: () => {
                                Swal.showLoading();
                            },
                        });
                        createTestRequest({...payload, paymentStatus: 'PAID'});
                        // } else {
                        //     Swal.fire('Payment Failed!', '', 'error');
                        // }
                    }
                };
                const razorpayObject = new window.Razorpay(options);
                razorpayObject.open();
            }
        } catch (error) {
            console.log(error);
            Swal.fire('Something Went Wrong!', '', 'error');
            createTestRequest(payload);
        } finally {
            Swal.hideLoading();
            setPlacingOrder(false);
        }
    };

    if (placingOrder) {
        return <Button variant='contained' className='small-brown-btn'>Placing Order&nbsp;<Spinner /></Button>;
    }
    return <Button variant='contained' className='small-brown-btn' onClick={handlePlaceOrder}>Place Order</Button>;
};

export default TestPlaceOrderBtn;